export enum FeatureFlagType {
  DoublonsEmploye = 1,
  DebugActions = 2,
  DebugErrorDetails = 3,
}

export interface FeatureFlagItem {
  id: number;
  name: string;
  description?: string;
  defaultEnabled: boolean;
}

export interface ClientFeatureFlagItem {
  featureFlagId: number;
  name: string;
  description?: string;
  defaultEnabled: boolean;
  isEnabled: boolean;
  isUsingDefault: boolean;
}

export interface UpdateClientFeatureFlagDto {
  clientId: number;
  featureFlagId: number;
  isEnabled: boolean | null;
}

export interface UpdateFeatureFlagDefaultDto {
  featureFlagId: number;
  defaultEnabled: boolean;
}

export interface EnableFeatureFlagForAllClientsDto {
  featureFlagId: number;
}

export interface DisableFeatureFlagForAllClientsDto {
  featureFlagId: number;
}

export interface ClientActivationDto {
  clientId: number;
  clientNom: string;
  isEnabled: boolean;
  isUsingDefault: boolean;
}

export interface FeatureFlagWithClientsDto {
  id: number;
  name: string;
  description?: string;
  defaultEnabled: boolean;
  clients: ClientActivationDto[];
}

export type FeatureFlagListResponse = FeatureFlagItem[];
export type ClientFeatureFlagListResponse = ClientFeatureFlagItem[];
export type FeatureFlagsWithClientsResponse = FeatureFlagWithClientsDto[];
